import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaintenancePageIcon from '../../Components/CustomIcons/MaintenancePageIcon';

const Maintenance = ({
  message = 'Estamos en mantenimiento, volveremos pronto.'
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <MaintenancePageIcon className={classes.icon} />
        <Typography variant="h1" className={classes.message}>
          {message}
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    padding: [[0, theme.spacing(2.5)]],
    width: '100%',
    display: 'flex',
    paddingTop: theme.spacing(6),
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: 0,
      paddingTop: theme.spacing(17.5)
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  icon: {
    marginBottom: theme.spacing(),
    transform: 'scale(0.75)',
    [theme.breakpoints.up('sm')]: {
      transform: 'scale(1)',
      marginBottom: theme.spacing(3)
    }
  },
  message: {
    marginBottom: theme.spacing(4),
    fontSize: '1em',
    textAlign: 'center',
    lineHeight: 1.19,
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(5),
      fontSize: '1.25em'
    }
  }
}));

export default Maintenance;
